import React, {Component} from 'react'
import {Form, Input, Header, Icon, Grid} from 'semantic-ui-react'
import PhoneInput from 'react-phone-number-input'
import 'react-phone-number-input/rrui.css'
import 'react-phone-number-input/style.css'

class AccountDetails extends Component {

    handleChange = (e) => {
        this.props.change(e.target.name, e.target.value)
    }
    handlePhoneChange = (e) => {
        this.props.change(e.target.name, e.target.value)
    }

    render() {
        return (
            <div>
                <Header as='h3' dividing>
                    <Icon name='phone square'/>
                    <Header.Content>
                        Account Contacts
                        <Header.Subheader>
                            Manage your account contacts and emergencies
                        </Header.Subheader>
                    </Header.Content>
                </Header>
                <Grid>

                    <Grid.Column mobile={16} tablet={16} computer={8}>
                        <Form.Field control={Input} label='Emergency Contact Name' placeholder='Emergency Contact Name'
                                    value={this.props.data.emergency_name}
                                    name='emergency_name' onChange={this.handleChange.bind(this)}/>

                        <Form.Field>
                            <label>Emergency Contact Phone</label>
                            <PhoneInput
                                country="US"
                                placeholder="Emergency Contact Phone"
                                value={this.props.data.emergency_phone}
                                onChange={value => this.props.change('emergency_phone', value)}/>
                        </Form.Field>

                        <Form.Field>
                            <label>Home Phone</label>
                            <PhoneInput
                                country="US"
                                placeholder="Home Phone"
                                value={this.props.data.home_phone}
                                onChange={value => this.props.change('home_phone', value)}/>
                        </Form.Field>

                    </Grid.Column>
                    <Grid.Column mobile={16} tablet={16} computer={8}>

                        <Form.Field control={Input} label='Local Police Department Name'
                                    value={this.props.data.police_name}
                                    placeholder='Local Police Department Name'
                                    name='police_name' onChange={this.handleChange.bind(this)}/>

                        <Form.Field>
                            <label>Local Police Department Phone</label>
                            <PhoneInput
                                country="US"
                                placeholder="Local Police Department Phone"
                                value={this.props.data.police_phone}
                                onChange={value => this.props.change('police_phone', value)}/>
                        </Form.Field>

                    </Grid.Column>
                    <Grid.Column mobile={16} tablet={16} computer={8}>

                    </Grid.Column>
                </Grid>
            </div>
        )
    }
}

export default AccountDetails


// WEBPACK FOOTER //
// ./src/containers/register/AccountDetails.js